<script>
export default {
  name: "FarmTabs",
  props: ["farm"],
  data: function () {
    return {
      tabsHTML: null,
      firstUpdate: true,
    }
  },
  mounted() {
    let div = document.getElementById('farm-tabs-template');
    this.tabsHTML = div.innerHTML;
  },
  updated() {
    if (this.firstUpdate) {
      window['xive']['loadTabs'](this.farm, this.$refs.div.querySelector('.farm-tabs'));
    } else {
      this.firstUpdate = false;
    }
  }
}
</script>

<template>
  <div v-html="tabsHTML" ref="div"></div>
</template>